import { createReducer } from '../../helpers/reducers';

import { types } from '../../actions/search';

const initialState = [];

const handleSearchQuerySuccess = (state, action) => {
  const { data } = action.payload;
  return data.map(result => result.id);
};

const handleSearchQueryFailure = () => [];

const handlers = {
  [types.SEARCH_QUERY.SUCCESS]: handleSearchQuerySuccess,
  [types.SEARCH_QUERY.FAILURE]: handleSearchQueryFailure,
};

const results = createReducer(initialState, handlers);

export default results;

export const getSearchResults = state => state.search.results;



// WEBPACK FOOTER //
// ./src/reducers/search/results.js